// extracted by mini-css-extract-plugin
export default {"FeatureTogglesSavedMessage":"featureTogglesSavedMessage_FeatureTogglesSavedMessage_gHs5V"};